/* eslint-disable max-len */
'use strict';

function contactForm(g) {
  // on déclare ici les variables propres à cette fonction
  var $demandeMacif = $('#acf-key_contact_macif_demande');
  var $messageMacif = $('#acf-key_contact_macif_message');
  var $demandeCourtier = $('#acf-key_contact_courtier_demande');
  var $demandeRemboursementCourtier = $('#acf-key_contact_courtier_remboursement');
  var $demandeContratCourtier = $('#acf-key_contact_courtier_contratinfo');
  var $toutesDemandesCourtier = $('#acf-key_contact_courtier_demande, #acf-key_contact_courtier_remboursement, #acf-key_contact_courtier_contratinfo');
  var $messageCourtier = $('#acf-key_contact_courtier_message');

  function init() {
    acf.unload.active = false;

    if ($demandeMacif.length) {
      $demandeMacif.on('change', function() {
        var formMacifType = $demandeMacif.val();

        if ( formMacifType == 'decompte' ) {
          $messageMacif.val('Bonjour, \n\nJe vous prie de trouver ci-joint mon décompte Assurance Maladie.\n\nMerci d’avance, \nCordialement. ');
        }
        if ( formMacifType == 'devis' ) {
          $messageMacif.val('Bonjour, \n\nJe vous prie de trouver ci-joint mon devis afin de connaître la prise en charge d\'Apivia sur cette prestation.\n\nMerci d’avance, \nCordialement. ');
        }
        if ( formMacifType == 'attestation' ) {
          $messageMacif.val('Bonjour, \n\nJe vous prie de trouver ci-joint mon attestation Sécurité Sociale.\n\nMerci d’avance, \nCordialement. ');
        }
        if ( formMacifType == 'carte' ) {
          $messageMacif.val('Bonjour, \n\nJe souhaite recevoir une nouvelle carte mutuelle - tiers payant.\n\nMerci d’avance, \nCordialement. ');
        }
        if ( formMacifType == 'info' || formMacifType == '' ) {
          $messageMacif.val('');
        }
      });
    } else if ($demandeCourtier.length) {
      $toutesDemandesCourtier.on('change', function() {
        var demande = $demandeCourtier.val();
        var demandeRemboursement = $demandeRemboursementCourtier.val();
        var demandeContrat = $demandeContratCourtier.val();
        var fieldsUpload = acf.findFields({
          type: 'multi_upload'
        });
        var labelPj = fieldsUpload.find('div.acf-label label');

        if ( demande == 'remboursement' && demandeRemboursement == 'decompte' ) {
          $messageCourtier.val('Bonjour, \n\nJe vous prie de trouver ci-joint les pièces justificatives pour remboursement.\n\nMerci d’avance, \nCordialement.');
          $(labelPj[0]).text('Pièce(s) jointe(s) à votre message *');
        } else if ( demande == 'remboursement' && demandeRemboursement == 'devis' ) {
          $messageCourtier.val('Bonjour, \n\nJe vous prie de trouver ci-joint un devis afin de connaître la prise en charge d\'Apivia sur cette prestation.\n\nMerci d’avance, \nCordialement.');
          $(labelPj[0]).text('Pièce(s) jointe(s) à votre message *');
        } else if ( demande == 'contrat' && demandeContrat == 'carte' ) {
          $messageCourtier.val('Bonjour, \n\nJe vous remercie de bien vouloir envoyer une nouvelle carte mutuelle à notre client.\n\nMerci d’avance, \nCordialement.');
          $(labelPj[0]).text('Pièce(s) jointe(s) à votre message');
        } else if ( demande == 'contrat' && demandeContrat == 'attestation' ) {
          $messageCourtier.val('Bonjour, \n\nJe vous prie de trouver ci-joint l\'attestation Sécurité Sociale.\n\nMerci d’avance, \nCordialement.');
          $(labelPj[0]).text('Pièce(s) jointe(s) à votre message *');
        } else {
          $messageCourtier.val('');
          $(labelPj[0]).text('Pièce(s) jointe(s) à votre message');
        }
      });
    }

    acf.add_filter('time_picker_args', function( args, field ) {
      args.hourMin = 8;
      args.hourMax = 19;
      args.stepMinute = 15;
      args.showSecond = false;
      return args;
    });
  }

  init();
}


